@if(isPpaRoute()) {
  <app-header />
  <app-banner />
  <router-outlet />
} @else {
  <router-outlet />
}
<app-footer />
